<template>
  <div class="tabList">
    <div class="align-right">
      <el-button type="primary" size="medium" icon="el-icon-arrow-left" @click="$router.push('/'+propsObj.link+'/'+ propsObj.propsId)">
        返回
      </el-button>
    </div>
    <el-main>
      <el-row :gutter="20" class="tabListRow">
        <el-col :span="8">
          <el-card class="tabListCard">
            <module-title title="基本信息" class="module-title" />
            <div class="list-item">
              <div class="imgbox">
                <img src="https://cunw-edu-res-test.oss-cn-hangzhou.aliyuncs.com/cloud/edu/courseware/thumb/20210108/797155673937940480.jpg?Expires=1620441134&OSSAccessKeyId=LTAI4FruwZcrEuuy99M7bH43&Signature=Ard%2BIwHStjKnVvgbjtEJHkwV7UA%3D" class="imgsrc">
              </div>
              <div class="text">
                <div class="title">
                  名师名称
                </div>
                <p>小学-语文</p>
                <p>省一级</p>
                <p>长沙市中南附二小</p>
              </div>
            </div>
            <div class="footer">
              <span>资源数：213</span><span>访问数：213</span><span>下载数：212</span>
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="tabListCard">
            <module-title title="资源统计" class="module-title" />
            <div class="list-item-imgbox">
              <img src="https://cunw-edu-res-test.oss-cn-hangzhou.aliyuncs.com/cloud/edu/courseware/thumb/20210108/797155673937940480.jpg?Expires=1620441134&OSSAccessKeyId=LTAI4FruwZcrEuuy99M7bH43&Signature=Ard%2BIwHStjKnVvgbjtEJHkwV7UA%3D" class="imgsrc">
            </div>
          </el-card>
        </el-col>
        <el-col :span="8">
          <el-card class="tabListCard">
            <module-title title="名师简介" class="module-title" />
            <div class="list-item-text">
              <p> ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar sic tempor. Sociis natoque penatibus et magnis dis parturient mon</p>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-card>
        <module-title title="资源列表" class="module-title" />
        <div>
          <div>
            <span> 格式：</span><ul class="item-li">
              <li>全部</li><li>文档</li>
            </ul>
          </div>
          <div>
            <span>排序：</span><ul class="item-li">
              <li>时间 </li><li>浏览</li>
            </ul>
          </div>
        </div>
        <div class="resoursList">
          <div class="list-item">
            <div class="imgbox">
              <img src="https://cunw-edu-res-test.oss-cn-hangzhou.aliyuncs.com/cloud/edu/courseware/thumb/20210108/797155673937940480.jpg?Expires=1620441134&OSSAccessKeyId=LTAI4FruwZcrEuuy99M7bH43&Signature=Ard%2BIwHStjKnVvgbjtEJHkwV7UA%3D" class="imgsrc">
            </div>
            <div class="text">
              <div class="title">
                1601198699180.docx<span class="right">5</span>
              </div>
              <p>简介：小学语文一年级上册 ，我上学了<span class="right">2020-10-24  13:35:34</span></p>
              <p><span>浏览数：213</span><span>下载数：213</span><span class="right"><i class="el-icon-download" />下载</span><span class="right"><i class="el-icon-view" />预览</span></p>
            </div>
          </div>
          <div class="list-item">
            <div class="imgbox">
              <img src="https://cunw-edu-res-test.oss-cn-hangzhou.aliyuncs.com/cloud/edu/courseware/thumb/20210108/797155673937940480.jpg?Expires=1620441134&OSSAccessKeyId=LTAI4FruwZcrEuuy99M7bH43&Signature=Ard%2BIwHStjKnVvgbjtEJHkwV7UA%3D" class="imgsrc">
            </div>
            <div class="text">
              <div class="title">
                1601198699180.docx<span class="right">5</span>
              </div>
              <p>简介：小学语文一年级上册 ，我上学了<span class="right">2020-10-24  13:35:34</span></p>
              <p><span>浏览数：213</span><span>下载数：213</span><span class="right"><i class="el-icon-download" />下载</span><span class="right"><i class="el-icon-view" />预览</span></p>
            </div>
          </div>
        </div>
      </el-card>
    </el-main>
  </div>
</template>
<script>
export default {
  name: 'TeacherDetail',
  props: {
    propsObj: {
      default: Object,
      type: Object
    }
  },
  data: () => {
    return {
    };
  },
  computed: {
  },
  mounted() {
  },
  methods: {
  }
};
</script>
<style scoped lang="scss">
.tabList{
  .tabListRow{
    margin-bottom: 20px ;
    .tabListCard{
      height: 234px;
    }
    .list-item-imgbox{
      width: 100%;
      height: 152px;
      border: 1px solid #999;
    }
    .list-item-text{
      line-height: 30px;
    }
  }
  .list-item {
    display: flex;
    .imgbox {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      border: 1px solid #999;
      .imgsrc {
        width: 100%;
        height: 100%;
      }
    }
    .text {
      flex: 1;
      margin-left: 40px;
      line-height: 30px;
      .title{
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .footer{
      margin-top: 20px;
      span{
        display: inline-block;
        width: 33.3333%;
      }
    }
    .item-li,.item-li li{
      display: inline-block;
    }
    .item-li li{padding: 5px 20px;}
    .resoursList{
      margin-top: 40px;
      .list-item {
        display: flex;
        border-top: 1px solid #e3e3e3;
        padding: 30px 0;
        .imgbox {
          width: 100px;
          height: 100px;
          border-radius: 0%;
          border: 1px solid #999;
          .imgsrc {
            width: 100%;
            height: 100%;
          }
        }
        .text {
          flex: 1;
          margin-left: 40px;
          line-height: 30px;
          .title{
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
      span{
        padding-right: 20px;
      }
    }
}
</style>
